import { useLocation, useNavigate } from 'react-router-dom';
import { getHeaderOffsetPx, scrollToSection } from '../utils/sectionNav';

function SectionLink({ sectionId, className, children, onClick, ...props }) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (event) => {
    event.preventDefault();

    if (location.pathname !== '/') {
      // Not on the homepage (e.g. a legal page) — navigate back and let
      // RouteEffects scroll to the section once the homepage has mounted.
      navigate(`/#${sectionId}`);
    } else {
      scrollToSection(sectionId, { offset: getHeaderOffsetPx() });
    }

    onClick?.(event);
  };

  return (
    <a
      href={`/#${sectionId}`}
      data-section={sectionId}
      className={className}
      onClick={handleClick}
      {...props}
    >
      {children}
    </a>
  );
}

export default SectionLink;
